import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EXPENSE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const expenseServiceApi = createApi({
  reducerPath: "expenseServiceApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: EXPENSE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "ExpenseEmployee",
    "ExpenseMonthlyDetails",
    "GetPettyCash",
    "GetPettyCashID",
    "GetPettyCashDetails",
  ],
  keepUnusedDataFor: 2,
  endpoints: () => ({}),
});
